/**
 * Hero Video
 */

export default function BOT_HeroVideo() {
	const selectors = {
		videoIcon: ".video-player",
		pause: "icon-pause",
		play: "icon-play",
		youtube: "youtube-video",
		vimeo: "vimeo-video",
		videoContainer: ".video-container",
		backVideo: ".background-video"
	};

	this.init = () => {
		jQuery(selectors.videoIcon).on("click", function(){
			if (jQuery(this).hasClass(selectors.pause)) {
				jQuery(this).removeClass(selectors.pause)
				jQuery(this).addClass(selectors.play)
				if (jQuery(this).hasClass(selectors.youtube)) {
					jQuery(this).siblings(selectors.videoContainer).children(selectors.backVideo).each(function() {
						this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
					});
				} else if (jQuery(this).hasClass(selectors.vimeo)) {
					jQuery(this).siblings(selectors.videoContainer).children(selectors.backVideo).each(function() {
						this.contentWindow.postMessage('{"method":"pause"}', '*')
					});
				}
			} else {
				jQuery(this).removeClass(selectors.play)
				jQuery(this).addClass(selectors.pause)
				if (jQuery(this).hasClass(selectors.youtube)) {
					jQuery(this).siblings(selectors.videoContainer).children(selectors.backVideo).each(function(){
						this.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
					});
				} else if (jQuery(this).hasClass(selectors.vimeo)) {
					jQuery(this).siblings(selectors.videoContainer).children(selectors.backVideo).each(function(){
						this.contentWindow.postMessage('{"method":"play"}', '*')
					});
				}
			}
		})
	};
}
